export default __webpack_public_path__ + "static/media/Codepen.34544ba7.svg";